import VisionImage from "../../../assets/logo/DSC_5463-1024x693-1.webp";
export default function ValuePropositionSection() {
  const benefits = [
    {
      icon: 'ri-focus-3-line',
      title: 'Precision Execution',
      description: 'Meticulous engineering-driven attention to detail, ensuring your exact markups and specifications are translated flawlessly.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Strictly Confidential Support',
      description: 'We operate as your silent, reliable back-office partner, protecting your proprietary data and your competitive bidding advantage. White Label.'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Scalable & Flexible Solutions',
      description: 'Whether you need a single 3D rendering or overflow support during peak bidding season, our services scale instantly to meet your demand.'
    },
    {
      icon: 'ri-time-line',
      title: 'Reliable Turnarounds',
      description: 'Predictable 24 to 48-hour delivery schedules that align perfectly with your deadlines.'
    }
  ];

  return (
    <section className="py-20 bg-[#dbcfbf]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <img
              src={VisionImage}
              alt="Professional Engineering Team"
              className="w-full h-96 object-cover object-top rounded-2xl shadow-xl"
            />
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#e18033] rounded-2xl flex items-center justify-center shadow-xl">
              <div className="text-center text-white">
                <div className="text-2xl font-bold">500+</div>
                <div className="text-sm">Projects</div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#212026] mb-6">
              Why Professionals Partner With DMI
            </h2>
            <p className="text-xl text-[#889d8f] mb-8 leading-relaxed">
              Our commitment to excellence and technical expertise makes us the preferred choice for professional design services.
            </p>

            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#e18033] rounded-lg flex items-center justify-center flex-shrink-0">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className={`${benefit.icon} text-white text-xl`}></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-[#212026] mb-2">
                      {benefit.title}
                    </h3>
                    <p className="text-[#889d8f] leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
